import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

var ReactDOM = require('react-dom')


export class FiksanaTrakaDoljeInfo extends React.Component {


    constructor(props) {
        super(props);

        // Create a div that we'll render the modal into. Because each
        // Modal component has its own element, we can render multiple
        // modal components into the modal container.
        this.el = document.createElement('div');

    }

    componentDidMount() {
        // Append the element into the DOM on mount. We'll render
        // into the modal container element (see the HTML tab).
        document.getElementById('modal').appendChild(this.el);
    }

    componentWillUnmount() {
        // Remove the element from the DOM when we unmount
        document.getElementById('modal').removeChild(this.el);
    }



    render() {

        let start = new Date(2000, 1, 1, new Date().getHours(), 0, 0, 0);


        if (this.props.popUpCode == "poceoHapyHour") {
            return ReactDOM.createPortal(
                <div className={"fixedTrakaDolje poceoHH  " + (this.props.activeHH ? 'active' : '')} >


                    <div className="HHSat">
                        {casino.utils.dateToTimeString(start)}
                    </div>

                    <div className="HHBody">
                        Počeo je "Happy Hour"<br />
                        <NavLink onClick={this.props.sakrijObavijest} to="/promotions/happy-hour"
                            className={"red btn small fill"}>Saznaj više</NavLink>

                        &nbsp;&nbsp;
                        <button className="gray btn small outline " onClick={this.props.sakrijObavijest}>Zatvori</button>


                    </div>




                    <div className="HHIkona"></div>

                </div>,
                this.el);

        }

        // zbog animacija moramo vratiti div
        return ReactDOM.createPortal(
            <div className={"fixedTrakaDolje"} >
            </div>,
            this.el);



    }
};
